import { Fade, LinearProgress } from "@mui/material";
import { makeStyles } from "@mui/styles";

import { getMediaLink } from "@/utils/mediaLink";

const useStyles = makeStyles(() => ({
  loadingBackground: {
    backgroundColor: "rgb(44, 44, 44)",
    position: "absolute",
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
    zIndex: 3,
  },
  container: {
    display: "flex",
    "justify-content": "center",
    position: "absolute",
    transform: "translate(-50%, -50%)",
    top: "50%",
    left: "50%",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
  },
  progressRoot: {
    width: "25%",
    height: 4,
    backgroundColor: "grey",
  },
  barPrimary: {
    backgroundColor: "white",
  },
  splashPageLogo: {
    maxWidth: "200px",
    maxHeight: "200px",
  },
}));

export default function VisualBuilderLoadingSplash(props) {
  const { brandingId, splashPageBackgroundColor, splashPageLogo, isLoading } = props;
  const classes = useStyles();

  return (
    <Fade in={brandingId && isLoading} timeout={2000} appear={false}>
      <div
        className={classes.loadingBackground}
        style={{ backgroundColor: splashPageBackgroundColor || "rgb(44, 44, 44)" }}
        data-testid="visual-builder-loading-splash"
      >
        <div className={classes.container}>
          {splashPageLogo ? (
            <img className={classes.splashPageLogo} src={getMediaLink({ link: splashPageLogo })} alt="logo" />
          ) : (
            <LinearProgress
              classes={{
                root: classes.progressRoot,
                barColorPrimary: classes.barPrimary,
              }}
            />
          )}
        </div>
      </div>
    </Fade>
  );
}
